import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaSaldosPrestamosComponent (FinancesPosicionbancariaPrestamos) {
  var $ctrl = this

  $ctrl.$onInit = $onInit

  function $onInit () {
    $ctrl.$promise = FinancesPosicionbancariaPrestamos.get($ctrl.idEmpresa, $ctrl.idCuenta, $ctrl.fechaInicial, $ctrl.fechaFinal)
      .then(function (resolve) {
        $ctrl.data = resolve.data

        $ctrl.total = $ctrl.data.reduce(function (total, item) {
          return total + item.importe
        }, 0)
      })
  }
}

module.component('financesPosicionbancariaSaldosPrestamos', {
  controller: FinancesPosicionbancariaSaldosPrestamosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
    fechaInicial: '<',
    fechaFinal: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/saldos/prestamos/component.js